import "../../../../style/less/marketing/spots/u-value.less";

function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
        _typeof = function _typeof(obj) {
            return typeof obj;
        };
    } else {
        _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
    }
    return _typeof(obj);
}
/*JS POLYFILL to support array find */
// https://tc39.github.io/ecma262/#sec-array.prototype.find
if (!Array.prototype.find) {
    Object.defineProperty(Array.prototype, 'find', {
        value: function (predicate) {
            // 1. Let O be ? ToObject(this value).
            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }

            var o = Object(this);

            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;

            // 3. If IsCallable(predicate) is false, throw a TypeError exception.
            if (typeof predicate !== 'function') {
                throw new TypeError('predicate must be a function');
            }

            // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
            var thisArg = arguments[1];

            // 5. Let k be 0.
            var k = 0;

            // 6. Repeat, while k < len
            while (k < len) {
                // a. Let Pk be ! ToString(k).
                // b. Let kValue be ? Get(O, Pk).
                // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                // d. If testResult is true, return kValue.
                var kValue = o[k];
                if (predicate.call(thisArg, kValue, k, o)) {
                    return kValue;
                }
                // e. Increase k by 1.
                k++;
            }

            // 7. Return undefined.
            return undefined;
        },
        configurable: true,
        writable: true
    });
}
/* END Polyfill*/
(function ($) {
    let productType,
        productTypeObj,
        windowType,
        windowVarient,
        colorBlue = 'blue-velux',
        colorRed = 'red-velux',
        colorYellow = 'yellow-velux',
        dataStore,
        formFields = $('.form-fields'),
        errorServer = $('.server-error'),
        rootItemId = $('#hfRootItemId').val(),
        currentLang = $('#hfCurrentLang').val(),
        loadIcon = $('#loadIcon'),
        baseUrl,
        dataForExport = [],
        csvTitle,
        selectedProduct,
        endpoint,
        errorResultMsg = $('#hfNoResultFound').val(); //'There are no results for this combination.';

    // Get Page settings on page load and assign data to a store variable.
    // populates the product sections and field forms

    $.ajax({
        url: '/api/sitecore/uvalue/getsettings?rootId=' + rootItemId + '&language=' + currentLang + '',
        method: 'GET'
    }).done(function (response) {
        loadIcon.hide();
        dataStore = response;
        baseUrl = response.Data.EndPoints.BaseUrl;
        loadProducts(response.Data.Products);
        loadProductsParamContainers(response.Data.Products[0].Parameters);
    }).fail(function () {
        console.log('error');
    }).always(function () {
        console.log('complete');
    });

    function getSettings(productType) {
        var productsArr = dataStore.Data.Products;
        var filtered = productsArr.filter(function (obj) {
            // return an array containing the object that matches the selection
            return obj.ProductKey == productType;
        });
        productTypeObj = filtered[0].Parameters;

        for (var key in filtered) {
            filtered = filtered[key].Parameters;
        }
        $.each(filtered, function (i, e) {
            $.each(filtered[i].Options, function (ii, ee) {
                if ($('#' + productType.toLowerCase() + ' select[name*="' + replaceSpaceForDash(e.ParameterKey) + '"] option').length <= filtered[i].Options.length) {
                    $('#' + productType.toLowerCase() + ' select[name*="' + replaceSpaceForDash(e.ParameterKey) + '"]').append($('<option>', {
                        value: ee.Key,
                        text: ee.Value
                    }));
                }
            });
        });
    }
    function loadProducts(data) {
        var productsArr = data,
            productContainer = $('#product-types'),
            title,
            dataWindow,
            imageSrc;

        for (var key in productsArr) {
            title = productsArr[key].ProductName;
            dataWindow = productsArr[key].ProductKey;
            imageSrc = productsArr[key].ProductImageSrc;
            productContainer.append('<div class= "grid_3"><label style="background-image: url(' + imageSrc + ')" class="window roof-window" data-window="' + dataWindow + '"><p>' + title + '</p></label></div >');
        }
    }

    function loadProductsParamContainers(data) {
        var parametersArr = data,
            productsArr = dataStore.Data.Products,
            title,
            productKey,
            counter;

        for (var key in productsArr) {
            counter = key;
            productKey = productsArr[key].ProductKey.toLowerCase();
            title = productsArr[key].ProductName;
            $('#' + productKey + ' .clone').prepend('<h3 class="grid_12">' + title + ' <span class="aux">1</span></h3>'); // TODO: Integrate these statements into the helper

            if (productKey == 'window') {
                for (var key2 in parametersArr) {
                    //fetchParameterNames(key2, parametersArr);
                    buildFormHelper(key2, productKey, parametersArr);
                }
            }

            if (productKey == 'flatroof') {
                for (key2 in productsArr[key].Parameters) {
                    buildFormHelper(key2, productKey, productsArr[key].Parameters);
                }
            }

            if (productKey == 'suntunnel') {
                for (key2 in productsArr[key].Parameters) {
                    buildFormHelper(key2, productKey, productsArr[key].Parameters);
                }
            }

            if (productKey == 'dormer') {
                for (key2 in productsArr[key].Parameters) {
                    buildFormHelper(key2, productKey, productsArr[key].Parameters);
                }
            }
        }
    } // HELPERS

    function buildFormHelper(key2, productKey, parametersArr) {
        var parameterKey, isRequired,
            parameterName = parametersArr[key2].ParameterName,
            parameterKey = parametersArr[key2].ParameterKey,
            isRequired = parametersArr[key2].IsRequired;
        return $('#' + productKey + ' .clone .form-row').append('<div class="form-group grid_2"><label>' + parameterName + '<span class="text-danger">' + isFieldRequired(isRequired) + '</span></label ><select name="' + replaceSpaceForDash(parameterKey) + '-1" class="form-control" ' + shouldAddRequired(isRequired) + '><option value="default"></option></select></div>');
    }

    function isFieldRequired(isRequired) {
        return isRequired ? '*' : '';
    }

    function shouldAddRequired(isRequired) {
        return isRequired ? 'required' : '';
    }

    function replaceSpaceForDash(str) {
        return str.replace(/\s+/g, '-').toLowerCase();
    }

    function onSubmitSend(token) {
        sendEmail(token);
    }

    function showErrorMessage(htmlNode) {
        htmlNode.addClass('box-danger');
        htmlNode.children('.error-container').html(errorResultMsg).show();
    }

    function cleanErrorMessages(index, item) {
        hideErrorMessage($(item));
    }

    function hideErrorMessage(htmlNode) {
        htmlNode.removeClass('box-danger');
        htmlNode.children('.error-container').html(errorResultMsg).hide();
    }

    function isResultsHidden(isHidden) {
        if (isHidden === true) {
            $('#results').hide();
            $('.export-results').hide();
        } else if (isHidden === false) {
            $('#results').show();
            $('.scroll-container').show();
            $('.export-results').show();
        }
    }

    function validateEmail(email) {
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    function validate() {
        var email = $("#textEmail").val();

        if (validateEmail(email)) {
            $('#btnSendEmail').prop('disabled', false);
            return true
        } else {
            $('#btnSendEmail').prop('disabled', true);
            return false;
        }

    }

    function sendEmail(token) {
        var emailAddress = $('#textEmail').val();

        if (emailAddress !== '') {
            var formData = new FormData();
            var rootId = $("#hfRootItemId").val();
            var language = $("#hfCurrentLang").val();
            formData.append("token", token);
            formData.append("email", emailAddress);
            formData.append("rootId", rootId);
            formData.append("language", language);

            var jsonObj = dataForExport;
            var json = JSON.stringify(jsonObj);
            formData.append("jsonStr", json);

            var settings = {
                "url": "/api/sitecore/uvalue/SendEmail",
                "method": "POST",
                "processData": false,
                "contentType": false,
                "data": formData
            };
            $.ajax(settings).done(function (response) {
                console.log(response);
            });
        }
    }
    $('#textEmail').on('input', function () {
        validate();
    });

    $('#btnSendEmail').on('click', function (e) {
        e.preventDefault();

        if ($("#recaptchaSend").attr("loaded") !== "true") {
            var captchaContainerSend = grecaptcha.render('recaptchaSend', {
                'sitekey': "6LfdZiIUAAAAALdnj11jmC8uQ0SdUJmsWGXueN7a",
                'callback': onSubmitSend,
                'size': "invisible"
            });
            $("#recaptchaSend").attr("loaded", "true");
        } else {
            grecaptcha.reset(captchaContainerSend);
        }

        grecaptcha.execute(captchaContainerSend);
    });
    $('#btnDownload').on('click', function (e) {
        e.preventDefault();
        exportCSVFile();
    });
    $('#btnDownloadXml').on('click', function (e) {
        e.preventDefault();
        exportXMLFile();
    });
    $('#btnDownloadCustomXml').on('click', function (e) {
        e.preventDefault();
        exportCustomXMLFile();
    });

    function convertToCSV(objArray) {
        var array = _typeof(objArray) != 'object' ? JSON.parse(objArray) : objArray;
        var str = "";
        var headerCounter = 0;

        for (var i = 0; i < array.length; i++) {
            var line = "";
            var header = "";

            for (var index in array[i]) {
                if (line != "") line += ';';
                line += array[i][index];
                if (header != "") header += ';';
                header += index;
            }

            if (headerCounter == 0) {
                str += header + '\r\n';
                headerCounter++;
            }

            str += line + '\r\n';
        }

        return str;
    }
    function exportXMLFile() {
        // Convert Object to JSON
        var jsonObject = JSON.stringify(dataForExport),
            xmlDoc,
            exportedFilename = csvTitle + '_velux.xml' || 'export.xml',
            xhr = new XMLHttpRequest();

        xhr.open("POST", "/api/sitecore/Uvalue/DownloadXml", true);
        xhr.setRequestHeader('Content-Type', 'application/json');

        xhr.onreadystatechange = function () {
            if (xhr.readyState == 4 && xhr.status == 200) {
                var oSerializer = new XMLSerializer(),
                    xmltext = oSerializer.serializeToString(xhr.responseXML);

                xmlDoc = '<?xml version="1.0" encoding="UTF-8"?>' + xmltext;

                var blob = new Blob([xmlDoc], {
                    type: 'text/xml;charset=utf-8;'
                });
                createDownloadLink(blob, exportedFilename);
            }
        };

        xhr.send(JSON.stringify({
            "jsonStr": jsonObject,
            "language": currentLang,
            "rootId": rootItemId
        }));
    }
    function exportCustomXMLFile() {
        // Convert Object to JSON
        var jsonObject = JSON.stringify(dataForExport),
            xmlDoc,
            exportedFilename = csvTitle + '_velux.xml' || 'export.xml',
            xhr = new XMLHttpRequest();

        xhr.open("POST", "/api/sitecore/Uvalue/DownloadCustomXml", true);
        xhr.setRequestHeader('Content-Type', 'application/json');

        xhr.onreadystatechange = function () {
            if (xhr.readyState == 4 && xhr.status == 200) {
                var oSerializer = new XMLSerializer(),
                    xmltext = oSerializer.serializeToString(xhr.responseXML);

                xmlDoc = '<?xml version="1.0" encoding="UTF-8"?>' + xmltext;

                var blob = new Blob([xmlDoc], {
                    type: 'text/xml;charset=utf-8;'
                });
                createDownloadLink(blob, exportedFilename);
            }
        };

        xhr.send(JSON.stringify({
            "jsonStr": jsonObject,
            "language": currentLang,
            "rootId": rootItemId
        }));
    }
    function exportCSVFile() {
        // Convert Object to JSON
        var jsonObject = JSON.stringify(dataForExport);
        var csv = convertToCSV(jsonObject);
        var exportedFilename = csvTitle + '_velux.csv' || 'export.csv';
        var blob = new Blob(["\uFEFF" + csv], {
            type: 'text/csv; charset=utf-8'
        });

        createDownloadLink(blob, exportedFilename);
    }

    function createDownloadLink(blob, exportedFilename) {
        if (navigator.msSaveBlob) {
            // IE 10+
            navigator.msSaveBlob(blob, exportedFilename);
        } else {
            var link = document.createElement("a");

            if (link.download !== undefined) {
                // feature detection
                // Browsers that support HTML5 download attribute
                var url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", exportedFilename);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    }
    //SELECT WINDOW
    $('body').on('click', '#product-types label', function () {
        isResultsHidden(true);
        $('label').each(function () {
            if ($(this).hasClass("checked")) {
                $(this).removeClass('checked');
            }
        });
        //errorContainer.hide();

        if (!$(this).hasClass('checked')) {
            $(this).removeClass('checked');
            $(this).addClass('checked');
            var indexSelect = 1;
            var url = "windowtypes";
            productType = $(this).data('window');
            selectedProduct = productType;
            endpoint = '/api/sitecore/uvalue/' + url + '?producttype=' + productType + '&lang=' + currentLang;
            getProd(url, productType, indexSelect, endpoint);
            getSettings(productType);
            formFields.show();
            formFields.children('div').each(function () {
                if ($(this).is("#" + productType.toLowerCase())) {
                    $(this).show().children().show();
                } else {
                    $(this).hide();
                }
            });
            validFields();
        }
    }); // // WINDOW TYPE

    $('body').on('change', 'select[name^="typesigntype"]', function () {

        var indexSelect = parseInt($(this).closest('.clone').find('.aux').html());
        $(this).closest('.form-row').find('select[name^="typesignsize"], select[name^="typesignvariant"]').each(function () {
            $('option[value!="default"]', this).remove();
        });

        if (productType != 'Dormer') {
            var url = "windowsizes";
            windowType = $(this).val();
            var windowTypeLocal = windowType + '/' + selectedProduct;
            endpoint = '/api/sitecore/uvalue/' + url + '?typesigntype=' + windowType + '&producttype=' + selectedProduct + '&lang=' + currentLang;
            getProd(url, windowTypeLocal, indexSelect, endpoint);
        } else {
            getSettings(productType);
        }
    }); // WINDOW SIZE

    $('body').on('change', 'select[name|="typesignsize"]', function () {
        var indexSelect = parseInt($(this).closest('.clone').find('.aux').html());
        $('select[name|="typesignvariant-' + indexSelect + '"]').each(function () {
            $('option[value!="default"]', this).remove();
        });
        var url = "windowvarients";
        windowVarient = windowType + '/' + $(this).val() + '/' + selectedProduct;
        endpoint = '/api/sitecore/uvalue/' + url + '?typesigntype=' + windowType + '&typesignsize=' + $(this).val() + '&lang=' + currentLang;
        getProd(url, windowVarient, indexSelect, endpoint);
    });
    $("body").on('change', 'select', function () {
        isResultsHidden(true);
        validFields();
    });

    function validFields() {
        var ok = 0;
        var length = $('#' + productType.toLowerCase() + ' select').filter('[required]').length;
        $('#' + productType.toLowerCase() + ' select:visible').each(function (i, e) {
            if ($(e).prop("required") && $(e).val() != "default") {
                ok++;
            }
        });

        if (ok === length) {
            $('.get-result').prop('disabled', false);
            $('#btnSendEmail').prop('disabled', true);
        } else {
            $('.get-result').prop('disabled', true);
        }
    }

    function getProd(url, productType, indexSelect, endpoint, source) {
        if (url == 'windowtypes') {
            $('#' + productType.toLowerCase() + ' select[name=typesigntype-' + indexSelect + ']').prop('disabled', true);
        }
        $.ajax({
            //url: '' + baseUrl + 'product/' + url + '/' + productType,
            url: endpoint,
            success: function success(data) {
                if (url == 'windowtypes') {
                    getTypes(data, indexSelect);
                } else if (url == 'windowsizes') {
                    getSizes(data, indexSelect);
                } else if (url == 'windowvarients') {
                    getVarients(data, indexSelect);
                }
            }
        });
    }

    function clearOptions(selectElement,) {
        if (selectElement.find('option:selected').length !== 0 && selectElement.val() !== 'default') return;
        selectElement.empty();
        selectElement.append($('<option>', {
            value: 'default',
            text: ''
        }));
    }

    function getTypes(data, indexSelect) {
        var selectElement = $('#' + productType.toLowerCase() + ' select[name=typesigntype-' + indexSelect + ']');
        clearOptions(selectElement);
        setTimeout(function () {
            selectElement.prop('disabled', false);
        }, 500);
        for (var key in data.Data) {
            $.each(data.Data[key], function (i, e) {
                if ($('#' + productType.toLowerCase() + ' select[name=typesigntype-' + indexSelect + '] option').length <= data.Data[key].length) {
                    $('#' + productType.toLowerCase() + ' select[name=typesigntype-' + indexSelect + ']').append($('<option>', {
                        value: e,
                        text: e
                    }));
                }
            });
        }
    }

    function getSizes(data, indexSelect) {
        $('select[name|="typesignsize-' + indexSelect + '"]').each(function () {
            $('option[value!="default"]', this).remove();
        });
        for (var key in data.Data) {
            $.each(data.Data[key], function (i, e) {
                $('#' + productType.toLowerCase() + ' select[name=typesignsize-' + indexSelect + ']').append($('<option>', {
                    value: e,
                    text: e
                }));
            });
        }
    }

    function getVarients(data, indexSelect) {
        $('select[name|="typesignvariant-' + indexSelect + '"]').each(function () {
            $('option[value!="default"]', this).remove();
        });

        for (var key in data.Data) {
            $.each(data.Data[key], function (i, e) {
                $('#' + productType.toLowerCase() + ' select[name=typesignvariant-' + indexSelect + ']').append($('<option>', {
                    value: e,
                    text: e
                }));
            });
        }
    } // BUTTONS


    $('body').on('click', '.add-fields', function (e) {
        e.preventDefault();
        $('.clone:visible').each(cleanErrorMessages);
        isResultsHidden(true);
        var title = productType.toLowerCase();
        var obj = $('#' + title + ' .clone:last');
        var helper = obj.find('.aux').text();
        helper = parseInt(helper);
        var clone = obj.clone();
        clone.find('.aux').html(helper + 1);
        clone.find('.rmv-fields').find('span').html('Remove Window ' + (helper + 1));
        clone.find('.rmv-fields').show();
        clone.find('select').each(function () {
            if ($(this).attr('name').indexOf('-')) {
                $(this).attr('name', $(this).attr('name').replace('-' + helper, '-' + (helper + 1)));
            }
        });

        hideErrorMessage(clone.find('.error-container'));
        $('#' + title + ' .clone:last').after(clone);
        validFields();
    });

    $("body").on('click', '.rmv-fields', function (e) {
        e.preventDefault();
        $(this).closest('.clone').remove();
        $('#' + productType.toLowerCase() + ' .clone').each(function (i, e) {
            var aux = $(e).find('.aux').html();
            var helper = i + 1;
            aux = parseInt(aux);
            $(e).find('select').each(function (x, y) {
                if ($(y).attr('name').indexOf('-')) {
                    $(y).attr('name', $(y).attr('name').replace('-' + aux, '-' + helper));
                }
            });
            $(e).find('.aux').html(helper);
            validFields();
        });
    });
    $("body").on('click', '.get-result', function (e) {
        e.preventDefault();
        $('.clone:visible').each(cleanErrorMessages);
        if (dataForExport.length >= 1) {
            dataForExport = [];
        }

        //var aux;
        var payload = {};
        var run = 1;
        $('.clone:visible').each(function (i, e) {

            productTypeObj.forEach(product => {
                let key = product.ParameterKey;
                payload[key] = $('#' + productType.toLowerCase() + ' select[name="' + key.toLowerCase() + '-' + (i + 1) + '"]').val();
                payload['RootItemId'] = $('#hfRootItemId').val();
                payload['Language'] = currentLang;
                payload['ProductType'] = productType;
            });
            for (let key in payload) {
                if (payload[key] === 'default') delete payload[key];
            }

            $.ajax({
                // url: '' + baseUrl + 'uvalue/search',
                url: '/api/sitecore/uvalue/search',
                method: 'POST',
                data: payload,
                success: function success(data) {
                    var productTypeCounter = $(e).find('.aux').html();
                    var filteredData = filterTable(productType, data.Data, productTypeCounter);
                    dataForExport.push(filteredData);

                    if ($.isEmptyObject(filteredData)) {
                        showErrorMessage($(e));

                    } else {
                        if (run === 1) {
                            errorServer.hide();
                            isResultsHidden(false);
                            $('#results .scroll-container').html('<table class="table"><tbody><tr id="table-titles"></tr><tr id="table-results"></tr></tbody></table>');
                            csvTitle = productType;
                            Object.getOwnPropertyNames(filteredData).forEach(function (i, e) {
                                $('.table > tbody #table-titles').append('<th class="' + coloredCell(i) + '">' + i + '</th>');
                            });
                            $('.table > tbody').append('<tr></tr>');
                            Object.values(filteredData).forEach(function (index, element) {
                                $('.table > tbody #table-results').append('<td>' + index + '</td>');
                            });
                        } else {
                            $('.table > tbody tr:last-child').after('<tr id="window' + run + '"></tr>');
                            Object.values(filteredData).forEach(function (index2, element2) {
                                $('.table > tbody #window' + run).append('<td>' + index2 + '</td>');
                            });
                        }

                        run++;
                    }
                },
                error: function error(errorMsg) {
                    $('#results').show();
                    $('.export-results').hide();
                    $('.scroll-container').hide();
                    $('.export-results').hide();

                    return (errorMsg.status === 500) ? errorServer.html(errorMsg.responseJSON.Message).show() : errorServer.html(errorMsg.statusText);
                }
            });
        });
    });

    function coloredCell(data) {
        switch (data) {
            case 'CE Reference size':
            case 'CE U-value':
            case 'CE Ug value':
            case 'CE Roof inclination':
            case 'Installation area':
            case 'Installation perimeter':
            case 'Linear heat loss built in':
            case 'U-value total Dormer':
            case 'Product type':
                return colorBlue;
            case 'Pane variant code':
            case 'Window type':
            case 'Window size':
            case 'Window variant':
                return colorRed;
            case 'Tube length':
            case 'Insulation':
            case 'Roof insulated':
            case 'Ceiling insulated':
            case 'Product configuration':
            case 'Roof inclination':
            case 'Accessory':
            case 'Accessory2':
                return colorYellow;
            default:
                return '';
        }
    }

    function filterTable(productType, data, productTypeCounter) {
        var productByNumber,
            outputFields,
            dataObj,
            object = {};

        productByNumber = dataStore.Data.Products.find(findProductByNumber);

        outputFields = productByNumber.OutputFields;

        dataObj = data[0] || [];

        if (dataObj && dataObj.length > 0) {
            isResultsHidden(true);

            return null;
        } else {
            $.each(outputFields, function (i, v) {
                $.each(dataObj, function (key, value) {
                    if (key === v.ParameterKey) {
                        var name = findName(outputFields, key);
                        if (name) {
                            if (productType === 'Window') {
                                productType = 'Roof window';
                            }
                            object["Product type"] = productType + ' ' + productTypeCounter;
                            object[name] = dataObj[key];

                        }
                    }
                });
            });
        }
        return object;
    }

    function findProductByNumber(el, index, arr) {
        var arrNumber;
        if (el.ProductKey === productType) {
            arrNumber = index;
            return el;
        }
    }

    function findName(dataArr, propKey) {
        var nameObj = dataArr.find(function (el) {
            return el.ParameterKey === propKey;
        });

        if (nameObj !== "undefined") {
            return nameObj.ParameterName;
        }
    } // Get the modal


    var modal = document.getElementById('exampleModal');
    // Get the button that opens the modal

    var btn = document.getElementsByClassName("button-info")[0]; // Get the <span> element that closes the modal

    var span = document.getElementsByClassName("close")[0]; // When the user clicks on the button, open the modal 

    btn.onclick = function (e) {
        e.preventDefault();
        modal.style.display = "block";
    }; // When the user clicks on <span> (x), close the modal


    span.onclick = function () {
        modal.style.display = "none";
    }; // When the user clicks anywhere outside of the modal, close it


    window.onclick = function (event) {
        if (event.target == modal) {
            modal.style.display = "none";
        }
    };
})(jQuery);